module.exports = __webpack_public_path__ + "img/creative-portfolio-light.7f4d2249.png";